#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment CtaCards on ctaCards_Entry {
    title
    description
    
    ctaCards {
        ... on ctaCard_Entry {
            __typename
            title
            description
            image {
                ... DefaultImageAsset
            }

            cta {
                ... CraftLink
            }
        }
    }
}
